import { useGetAllExamCentersQuery } from '@exam-center/graphql';
import { FormSearchMultipleSelection, type OptionSelectionProps } from '@shared/components';
import { useMemo } from 'react';

interface ExamCenterSearchSelectionProps {
  value: string[];
}

export default function ExamCenterSearchSelection(props: Readonly<ExamCenterSearchSelectionProps>) {
  const { value } = props;
  const { data } = useGetAllExamCentersQuery();

  const examCenterOptions = useMemo(() => {
    return [...(data?.ecGetAllExamCenters?.examCenters ?? [])]
      .sort((a, b) => a.examCenterId - b.examCenterId)
      .map((examCenter) => ({
        label: examCenter.code,
        value: examCenter.code,
      }));
  }, [data]);

  const selectedOptions = useMemo(
    () =>
      value
        .filter((val) => examCenterOptions.some((option) => option.value === val))
        .map((val) =>
          examCenterOptions.find((option) => option.value === val),
        ) as OptionSelectionProps[],
    [value, examCenterOptions],
  );

  return (
    <FormSearchMultipleSelection
      name='examCenters'
      options={examCenterOptions}
      label='ศูนย์ทดสอบ'
      value={selectedOptions}
      sx={{ width: '100%' }}
      slotProps={{
        input: {
          placeholder: value.length === 0 ? 'แสดงทั้งหมด' : '',
        },
      }}
    />
  );
}
